import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VatNumberComponent } from './vat-number/vat-number.component';
import { FormsModule } from '@angular/forms';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { BillingContactsComponent } from './billing-contacts/billing-contacts.component';
import { CreditCardDateComponent } from './credit-card-date/credit-card-date.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { MatButtonModule } from '@angular/material/button';
import { FiErrorMessageModule } from '@fi-shared/fi-error-message';
import { FiContactsModule } from '@fi-shared/fi-contacts/fi-contacts.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        UtilitiesModule,
        MatFormFieldModule,
        MatInputModule,
        SelectSearchModule,
        MatButtonModule,
        FiErrorMessageModule,
        FiContactsModule,
    ],
    declarations: [VatNumberComponent, BillingContactsComponent, CreditCardDateComponent],
    exports: [VatNumberComponent, BillingContactsComponent, CreditCardDateComponent],
})
export class BillingComponentsModule {}
